module.exports = __webpack_public_path__ + "static/img/193_TO8_2089_og.a84e4be.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/193_TO8_2089_og.jpg
// module id = 3DXZ
// module chunks = 0